import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="relative bg-foreground-950 rounded-2xl overflow-visible">
            <div className="absolute -top-6 -left-4 z-0 hidden md:block">
              <svg width="120" height="120" viewBox="0 0 120 120" fill="none" className="opacity-10">
                <path d="M10 80 Q 40 10, 70 40 T 110 60" stroke="oklch(0.68 0.185 27)" strokeWidth="1.5" fill="none" opacity="0.3"/>
                <path d="M5 90 Q 30 30, 60 50 T 105 70" stroke="oklch(0.68 0.185 27)" strokeWidth="1" fill="none" opacity="0.2"/>
                <circle cx="45" cy="25" r="3" fill="oklch(0.68 0.185 27)" opacity="0.25"/>
                <circle cx="80" cy="55" r="2" fill="oklch(0.68 0.185 27)" opacity="0.2"/>
              </svg>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
              <div className="md:col-span-1 relative">
                <div className="h-64 md:h-full w-full overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Happy%20customer%20unboxing%20fashion%20package%20on%20warm%20neutral%20background%2C%20lifestyle%20product%20photography%2C%20soft%20natural%20lighting%2C%20authentic%20genuine%20moment%2C%20clean%20minimal%20aesthetic%2C%20neutral%20warm%20tones%2C%20editorial%20style%2C%20satisfaction%20expression&width=600&height=900&seq=trust-photo-01&orientation=portrait"
                    alt="Customer review"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="md:col-span-2 flex flex-col justify-center p-8 md:p-12 lg:p-14">
                <div className="mb-6">
                  <span className="text-accent-300 text-6xl md:text-7xl font-heading leading-none">&ldquo;</span>
                </div>
                <blockquote className="text-background-50 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
                  {t('trust.quote')}
                </blockquote>
                <div className="mb-8">
                  <p className="text-background-50 text-sm font-semibold">{t('trust.name')}</p>
                  <p className="text-background-100/50 text-xs mt-0.5">{t('trust.role')}</p>
                </div>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center px-8 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer w-fit"
                >
                  {t('trust.button')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}